import { render, staticRenderFns } from "./Repwd.vue?vue&type=template&id=6aa6330c&"
import script from "./Repwd.vue?vue&type=script&lang=js&"
export * from "./Repwd.vue?vue&type=script&lang=js&"
import style0 from "./Repwd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports